import { useState, useEffect } from 'react';
import { ProductInfoViewType } from '../types/view/product-info-view-type';
import { RecommendProductInfoViewType } from '../types/view/recommend-product-info-view-type';
import { RecommendProductVariantsApiType } from '../types/api/recommend-product-variants-api-type';

export const useRecommendProducts = (
  registeredProducts: ProductInfoViewType[],
  recommendProductsData: RecommendProductVariantsApiType
) => {
  const [recommendProducts, setRecommendProducts] = useState<RecommendProductInfoViewType[]>([]);

  useEffect(() => {

    const filtered = recommendProductsData.reduce((accumlator, current) => {

      // プランが一つのみの場合を想定。それ以上の場合はsellingPlanIdも考慮する必要あり
      const notFoundInRegisteredProducts = registeredProducts.every((product) => {
        return product.variantId !== current.variantId;
      });

      if (notFoundInRegisteredProducts) {

        accumlator.push({
          productTitle: current.productTitle,
          image: current.image,
          variantTitle: current.variantTitle,
          originalPrice: current.originalPrice,
          price: current.price,
          quantity: 0,
          variantId: current.variantId,
          planId: current.planId,
          message: current.message,
          url: current.url,
          active: false,
        });
      }

      return accumlator;

    }, [] as RecommendProductInfoViewType[]);

    setRecommendProducts(filtered);

  }, [registeredProducts, recommendProductsData]);

  return recommendProducts;
};
